var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgJcb = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 28,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M25.358 16.82h2.381c.068 0 .227-.023.295-.023.454-.096.84-.528.84-1.129 0-.576-.386-1.008-.84-1.128-.068-.024-.204-.024-.295-.024h-2.381v2.305Z",
  fill: "url(#jcb_svg__a)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M27.467.904c-2.268 0-4.128 1.945-4.128 4.37V9.81h5.829c.136 0 .295 0 .408.024 1.316.072 2.29.792 2.29 2.04 0 .985-.657 1.825-1.881 1.993v.048c1.338.096 2.358.888 2.358 2.113 0 1.32-1.134 2.184-2.63 2.184h-6.397v8.883h6.056c2.268 0 4.128-1.945 4.128-4.37V.905h-6.033Z",
  fill: "url(#jcb_svg__b)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M28.578 12.164c0-.577-.385-.96-.839-1.033-.045 0-.158-.024-.226-.024h-2.155v2.113h2.155c.068 0 .204 0 .226-.024.454-.072.84-.456.84-1.032Z",
  fill: "url(#jcb_svg__c)"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M4.65.904C2.383.904.524 2.85.524 5.277v10.79c1.156.6 2.358.985 3.56.985 1.43 0 2.2-.913 2.2-2.163V9.795h3.539v5.07c0 1.97-1.157 3.58-5.08 3.58-2.382 0-4.242-.552-4.242-.552v9.203h6.056c2.268 0 4.128-1.947 4.128-4.373V.904H4.65Z",
  fill: "url(#jcb_svg__d)"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M16.058.904c-2.268 0-4.127 1.943-4.127 4.365v5.709c1.043-.936 2.857-1.535 5.783-1.391 1.565.072 3.244.527 3.244.527v1.847c-.84-.456-1.838-.863-3.13-.96-2.223-.167-3.561.984-3.561 2.999 0 2.039 1.338 3.19 3.56 2.998 1.293-.096 2.291-.527 3.13-.96v1.848s-1.655.455-3.243.527c-2.926.144-4.74-.456-5.783-1.39v10.073h6.055c2.268 0 4.128-1.943 4.128-4.365V.904h-6.056Z",
  fill: "url(#jcb_svg__e)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "jcb_svg__a",
  x1: 23.327,
  y1: 15.677,
  x2: 33.521,
  y2: 15.677,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#007940"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.229,
  stopColor: "#00873F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.743,
  stopColor: "#40A737"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5CB531"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "jcb_svg__b",
  x1: 23.327,
  y1: 14.008,
  x2: 33.511,
  y2: 14.008,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#007940"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.229,
  stopColor: "#00873F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.743,
  stopColor: "#40A737"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5CB531"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "jcb_svg__c",
  x1: 23.327,
  y1: 12.171,
  x2: 33.52,
  y2: 12.171,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#007940"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.229,
  stopColor: "#00873F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.743,
  stopColor: "#40A737"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5CB531"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "jcb_svg__d",
  x1: 0.51,
  y1: 14.008,
  x2: 10.86,
  y2: 14.008,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1F286F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.475,
  stopColor: "#004E94"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.826,
  stopColor: "#0066B1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#006FBC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "jcb_svg__e",
  x1: 11.864,
  y1: 14.008,
  x2: 21.916,
  y2: 14.008,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6C2C2F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.173,
  stopColor: "#882730"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.573,
  stopColor: "#BE1833"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.859,
  stopColor: "#DC0436"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E60039"
})))));
export default SvgJcb;